/* ============================================================
   ceg-card-video.js — site-wide hover-play for product cards.

   Targets every element with `data-ceg-card-hover`. On pointerenter the
   `[data-ceg-card-video]` inside it lazy-loads its src (read from data-src)
   and plays muted/looped; on pointerleave it pauses. Adds/removes the
   `is-card-playing` class on the wrapper so CSS can crossfade the video
   over the image.

   Idempotent — won't double-wire if called more than once (Shopify section
   re-render in the customizer fires it again). Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  if (window.__cegCardVideoInit) return;
  window.__cegCardVideoInit = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wire(card) {
    if (card.__cegCardVideoWired) return;
    card.__cegCardVideoWired = true;
    var vid = card.querySelector('[data-ceg-card-video]');
    if (!vid) return;
    var loaded = false;

    function play() {
      if (prefersReduced) return;
      if (!loaded) { vid.src = vid.dataset.src; loaded = true; }
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
      card.classList.add('is-card-playing');
    }
    function stop() {
      card.classList.remove('is-card-playing');
      try { vid.pause(); } catch (e) {}
    }

    card.addEventListener('pointerenter', play);
    card.addEventListener('pointerleave', stop);
    card.addEventListener('focusin',  play);
    card.addEventListener('focusout', stop);
  }

  function wireAll(root) {
    (root || document).querySelectorAll('[data-ceg-card-hover]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wireAll(); });
  } else {
    wireAll();
  }

  // Re-wire after Shopify section render (customizer / theme editor) and
  // after AJAX cart updates that may rerender card grids.
  document.addEventListener('shopify:section:load', function (e) { wireAll(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { wireAll(e.target); });
  document.addEventListener('ceg:cards:rerendered', function (e) { wireAll(e.target || document); });
})();
